import React, { createContext, useContext } from 'react';
import type { UploadMediaFn } from '../shared/types/public';

const UploadMediaContext = createContext<UploadMediaFn | null>(null);

export const UploadMediaProvider: React.FC<{
  uploadMedia?: UploadMediaFn;
  children: React.ReactNode;
}> = ({ uploadMedia, children }) => (
  <UploadMediaContext.Provider value={uploadMedia ?? null}>{children}</UploadMediaContext.Provider>
);

export const useUploadMedia = (): UploadMediaFn | null => useContext(UploadMediaContext);
